<template>
  <div class="signature-invoice" @click="openInvoice">
    <div>
      <VIcon v-if="status === 'pending'" color="#E8A43D">mdi-clock-time-five-outline</VIcon>
      <VIcon v-if="status === 'overdue'" color="#DA4343">mdi-close-circle-outline</VIcon>
      <div class="check-circle" v-if="['confirmed', 'received'].includes(this.status)">
        <VIcon color="#FFF" size="large">mdi-check</VIcon>
      </div>
    </div>
    <div>{{ date }}</div>
    <div style="flex-grow: 1">
      <div :class="`status ${status}`">{{ statusName }}</div>
    </div>
    <div>R$ {{ price }}</div>
    <div><VIcon>mdi-chevron-right</VIcon></div>
  </div>
</template>
<script>
export default {
  name: 'Invoice',
  props: {
    invoice: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      status: null,
      date: null,
      price: null,
      invoiceUrl: null
    };
  },
  watch: {
    invoice: {
      handler(newVal) {
        this.formatInvoice(newVal);
      },
      deep: true
    }
  },
  mounted() {
    this.formatInvoice(this.invoice);
  },
  computed: {
    statusName() {
      if (this.status === 'pending') return 'Pendente';
      if (['confirmed', 'received'].includes(this.status)) return 'Recebida';

      return 'Atrasada';
    }
  },
  methods: {
    formatInvoice({ status, value, dueDate, invoiceUrl }) {
      this.status = status.toLowerCase();
      this.price = value.toFixed(2);
      this.invoiceUrl = invoiceUrl;

      const [year, month, day] = dueDate.split('-');

      this.date = `${day}/${month}/${year}`;
    },
    openInvoice() {
      window.open(this.invoiceUrl, '_blank');
    },
  }
};
</script>
<style lang="scss" scoped>
.signature-invoice {
  border-radius: 8px;
  background: #fff;
  padding: 12px;
  display: flex;
  margin-bottom: 8px;
  color: #3f505f;
  font-size: 12px;
  font-weight: 500;
  gap: 8px;
  align-items: center;

  .status {
    font-size: 12px;
    font-weight: 500;
    border-radius: 4px;
    padding: 2px 8px;
    width: fit-content;
    &.pending {
      color: #e8a43d;
      background-color: #fdf8f0;
    }

    &.late {
      color: #da4343;
      background-color: #fcf0f0;
    }

    &.received {
      color: #48b48d;
      background-color: #f1f9f6;
    }
  }

  .check-circle {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    border-radius: 50%;
    background-color: #48b48d;
  }
}
</style>
